/**
 * Minimal stub for zod's default English locale.
 * Replaces the full locale module to reduce bundle size (~3KB).
 * Used by webpack NormalModuleReplacementPlugin when bundling zod.
 * Must use CommonJS so zod's .cjs chain can require it.
 */
module.exports = function () {
  return {
    localeError: (issue) =>
      (issue && typeof issue.message === 'string' ? issue.message : 'Invalid input'),
  };
};
